(function () {
  function parseBool(v) {
    return v === true || v === 'true' || v === '1';
  }

  function init(sectionRoot) {
    const el = sectionRoot.querySelector('.custom-swiper-gallery__swiper');
    if (!el || typeof Swiper === 'undefined') return;
    if (el.dataset.swiperInitialized === 'true') return;

    const autoplayEnabled = parseBool(el.dataset.autoplay);
    const delay = Number(el.dataset.delay || 5000);
    const speed = Number(el.dataset.speed || 350);
    const loop = parseBool(el.dataset.loop);

    const slidesDesktop = Number(el.dataset.slidesDesktop || 2);
    const slidesTablet = Number(el.dataset.slidesTablet || 2);
    const slidesMobile = Number(el.dataset.slidesMobile || 1);
    const gap = Number(el.dataset.gap || 16);

    const fit = el.dataset.fit || 'cover';
    const hDesktop = Number(el.dataset.tileHeightDesktop || 520);
    const hTablet = Number(el.dataset.tileHeightTablet || 440);
    const hMobile = Number(el.dataset.tileHeightMobile || 360);

    // Drive CSS via variables so it’s consistent and predictable
    el.style.setProperty('--img-fit', fit);

    function applyTileHeight() {
      const w = window.innerWidth;
      const h = w >= 990 ? hDesktop : w >= 750 ? hTablet : hMobile;
      el.style.setProperty('--tile-height', `${h}px`);
    }
    applyTileHeight();

    const paginationEl = el.querySelector('.swiper-pagination');
    const prevEl = el.querySelector('.swiper-button-prev');
    const nextEl = el.querySelector('.swiper-button-next');

    const usesNumbers = !!sectionRoot.querySelector('.custom-swiper-gallery__pagination') &&
      (sectionRoot.innerHTML.includes('slider_visual') ? false : false); // harmless; pagination mode decided below

    const swiper = new Swiper(el, {
      loop,
      speed,
      spaceBetween: gap,
      slidesPerView: 'auto',
      watchOverflow: true,

      breakpoints: {
        750: { slidesPerView: slidesTablet },
        990: { slidesPerView: slidesDesktop }
      },

      autoplay: autoplayEnabled
        ? { delay, disableOnInteraction: false }
        : false,

      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true
          }
        : undefined,

      navigation: prevEl && nextEl ? { prevEl, nextEl } : undefined,

      on: {
        init: function () {
          syncCounter(sectionRoot, this);
        },
        slideChange: function () {
          syncCounter(sectionRoot, this);
        }
      }
    });

    // Optional: if you want “numbers” pagination, you can switch this on by changing pagination.renderBullet,
    // but since you are controlling via schema (dots/numbers/counter), simplest is:
    // - dots/numbers => swiper pagination
    // - counter => our counter below
    // If you want numbers instead of dots, tell me and I’ll wire renderBullet to output 1..N.

    const toggleBtn = sectionRoot.querySelector('[data-swiper-toggle]');
    if (toggleBtn && swiper.autoplay) {
      toggleBtn.addEventListener('click', function () {
        if (swiper.autoplay.running) swiper.autoplay.stop();
        else swiper.autoplay.start();
        toggleBtn.classList.toggle('is-paused', !swiper.autoplay.running);
      });
    }

    window.addEventListener('resize', applyTileHeight);

    el.dataset.swiperInitialized = 'true';
    el._swiperInstance = swiper;
  }

  function syncCounter(sectionRoot, swiper) {
    const current = sectionRoot.querySelector('.custom-swiper-gallery__counter-current');
    const total = sectionRoot.querySelector('.custom-swiper-gallery__counter-total');
    if (!current || !total) return;

    current.textContent = String(swiper.realIndex + 1);
    // total slides equals original slides count (not duplicated)
    const originals = sectionRoot.querySelectorAll('.custom-swiper-gallery__slide').length;
    total.textContent = String(originals);
  }

  function initAll() {
    document.querySelectorAll('.custom-swiper-gallery').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  // Shopify editor support
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    const el = e.target.querySelector('.custom-swiper-gallery__swiper');
    if (el && el._swiperInstance) el._swiperInstance.destroy(true, true);
  });
})();
